import {createSvgIcon} from '../create-svg-icon';

export const DensityLargeIcon = createSvgIcon(
  <path d="M3 3h18v2H3zm0 16h18v2H3z" />
, 'DensityLargeOutlined');
